const INITIAL_STATE = {
    user: null,
    tokenId: null,
    refreshToken: null,
    reload: 0,
    auditoria: null,
    loged: false,
    isCadastrado: true,
    caixaAberto: false,
    alertas: null,
    conexao: null,
    chavePdv: null,
    idCadastro: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'LOGIN':
            localStorage.setItem("lastuser", action.dados.user);
            return { ...state, ...action.dados };
        case 'SETLOGED':
            return { ...state, loged: action.loged };
        case 'CADASTRAR':

            localStorage.setItem("conexao", action.dados.conexao);
            localStorage.setItem("chavePdv", action.dados.chavePdv);
            localStorage.setItem("versao", action.dados.versao);

            return { ...state, isCadastrado: true, ...action.dados };
        case 'SETCADASTRO':

            if (action.dados.acessoRevogado) {
                localStorage.removeItem("conexao");
                localStorage.removeItem("chavePdv");
            }

            return { ...(action.isCadastrado ? state : INITIAL_STATE), ...action.dados, conexao: localStorage.getItem("conexao"), chavePdv: localStorage.getItem("chavePdv") };
        case 'SETCAIXA':
            return { ...state, caixaAberto: action.isAberto };
        case 'SETALERTAS':
            return { ...state, alertas: [...(state?.alertas || []), ...(action?.alertas || [])] };
        case 'REMOVEALERTA':
            return { ...state, alertas: state.alertas.filter(s => s != action.alerta) };
        case 'LIMPARALERTAS':
            return { ...state, alertas: [] };
        case 'LOGOUT':
            return { ...INITIAL_STATE, ambiente: state.ambiente, alertas: state.alertas };
        default:
            return state;
    }
};